import { useModalFormW8BENCertification } from "../../ModalW8BENCertification/useModalFormW8BENCertify";
import { WSButton } from "@wingspanhq/fe-component-library";
import React from "react";
import { NotificationTemplate } from "../index";

export const W8BENCertification: NotificationTemplate<never> = {
  renderTitle: props => "W-8 BEN certification required",
  renderBody: props => {
    return "You have not yet certified your W-8 BEN information. Please certify your W-8 BEN information is accurate in order to get paid.";
  },
  Footer: props => {
    const consentModal = useModalFormW8BENCertification();

    return (
      <WSButton.Link
        size="S"
        rightIcon="chevron-right"
        onClick={() => {
          consentModal.open({});
        }}
      >
        Certify W-8 BEN information
      </WSButton.Link>
    );
  }
};
